import OrderingTool from './OrderingTool';

export default OrderingTool;
